const DELETE = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
  <path d="M7.49219 3.38281H12.4922M2.49219 5.88281H17.4922M15.8255 5.88281L15.2411 14.6489C15.1534 15.9641 15.1096 16.6217 14.8255 17.1203C14.5754 17.5593 14.1982 17.9122 13.7436 18.1325C13.2272 18.3828 12.5681 18.3828 11.25 18.3828H8.7344C7.41628 18.3828 6.75721 18.3828 6.2408 18.1325C5.78615 17.9122 5.40893 17.5593 5.15884 17.1203C4.87478 16.6217 4.83094 15.9641 4.74326 14.6489L4.15885 5.88281" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
</svg>`;

export default DELETE;
